<template>
  <div class="space-prop">
    <!-- 目前没属性 -->
  </div>
</template>

<script>

export default {
  name: 'SpaceProp',
  props: {
    info: Object,
  },
}
</script>